import { CountResponse } from '@interfaces/common.interface';
import {
  CountGendersRequestParams,
  CreateGenderRequest,
  Gender,
  GetGendersRequestParams,
  UpdateGenderRequest,
} from '@interfaces/genders.interface';

import api from './';

export const {
  useCountGendersQuery,
  useGetManyGendersQuery,
  useCreateGenderMutation,
  useUpdateGenderMutation,
  useDeleteGenderMutation,
} = api.injectEndpoints({
  endpoints: (build) => ({
    countGenders: build.query<CountResponse, CountGendersRequestParams>({
      query: (params) => ({ url: 'genders/count', params }),
      providesTags: ['genders'],
    }),
    getManyGenders: build.query<Gender[], GetGendersRequestParams>({
      query: (params) => ({ url: 'genders', params }),
      providesTags: ['genders'],
    }),
    createGender: build.mutation<Gender, CreateGenderRequest>({
      query: (body) => ({
        url: 'genders',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['genders'],
    }),
    updateGender: build.mutation<Gender, UpdateGenderRequest>({
      query: ({ id, body }) => ({
        url: `genders/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['genders'],
    }),
    deleteGender: build.mutation<Gender, string>({
      query: (id) => ({
        url: `genders/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['genders'],
    }),
  }),
});
